import { SettingsEntry } from '@features/user-settings';
import FormToggle from '@frontend/components/FormToggle';
import { defineComponent, h } from 'vue';
import cookie from './cookie.svg';
import { px } from '@phi/util/css';

export const CookieConsentSetting = defineComponent({
    props: {
        consent: {
            required: true,
            type: Boolean,
        }
    },

    emits: {
        'update:consent': (x: boolean) => true,
    },

    setup(props, { emit }) {
        return () => SettingsEntry(
            'Consent to cookies',

            `We use cookies to deliver and maintain our services,
            protect against fraud, and measure user engagement
            with new features to enhance the quality of our services`,

            h('img', {
                src: cookie,
                style: {
                    padding: px(4),
                },
                alt: 'cookie consent',
            }),

            h(FormToggle, {
                value: props.consent,
                'onUpdate:value': x => emit('update:consent', x),
            }),
        );
    },
});
